import axios from 'axios'
import deviceId from '../../helpers/device_id'

const activeLang = document.getElementsByTagName('html')[0].getAttribute('lang')

const common = {
  namespaced: true,

  state: {
    innerWidth: window.innerWidth,
    deviceId,
    title: null,
    langs: [],
    activeLang,
    menu: [],
    rooms: [],
    loading: true,
    virtual: {
      isVirtual: false,
      showScore: true,
      sessionBar: {},
      partnersBar: {
        show: false,
      },
      menuTitle: '',
      showRoomsSelect: false,
      multipleRooms: {
        defaultRoom: null,
        switchContent: 'default',
        switchContentConfig: '',
        menuItemName: '',
      },
      videosConfig: {},
      forcedStream: null,
    },
    places: {
      welcome_message: '',
    },
    smileys: {
      allowed_array: [],
    },
    contactInfo: {
      email: '',
      phone: '',
    },
    footer: {
      enabled: false,
      content: '',
    },
    speakerDetailEnabled: false,
    interactiveViewHidden: false,
    settingsDialogVisible: false,
    toolbarTabs: [],
    activeTab: -1,
  },

  mutations: {
    setData(
      state,
      {
        title,
        langs,
        activeLang,
        menu,
        rooms,
        virtual,
        smileys,
        places,
        layout,
        footer,
        contact_info,
        speaker_detail_enabled,
      }
    ) {
      state.title = title
      state.langs = langs
      state.activeLang = activeLang
      state.menu = menu
      state.rooms = rooms
      state.virtual = {
        ...virtual,
        forcedStream: null,
      }
      state.smileys = smileys
      state.places = places
      state.layout = layout
      state.footer = footer
      state.contactInfo = contact_info
      state.speakerDetailEnabled = speaker_detail_enabled
    },

    setLoading(state, loading) {
      state.loading = loading
    },

    saveSettings(state, settings) {
      state.virtual.isVirtual = settings.virtual.is_virtual
      state.virtual.visitorCanSwitch = settings.virtual.visitor_can_switch
      state.virtual.showScore = settings.virtual.show_score
      state.virtual.sessionBar = settings.virtual.session_bar
      state.virtual.partnersBar = settings.virtual.partners_bar
      state.virtual.menuTitle = settings.virtual.menu_title
      state.virtual.showRoomsSelect = settings.virtual.show_rooms_select
      state.virtual.multipleRooms = settings.virtual.multiple_rooms
      if (settings.smileys) {
        state.smileys = settings.smileys
      }
      state.virtual.videosConfig = Object.assign(
        {},
        state.virtual.videosConfig,
        settings.virtual.videos_config
      )
    },

    switchStreamToSessionRecord(state, url) {
      state.virtual.forcedStream = {
        type: 'record',
        config: url,
        placeholder: {
          show: false,
        },
      }
    },

    setInteractiveViewHidden(state, hidden) {
      state.interactiveViewHidden = hidden
    },

    changeSmileysVisibility(state, { roomId, smileysEnabled }) {
      const found = _.find(state.rooms, { id: roomId })
      found.smileys_enabled = smileysEnabled
    },

    changeSettingsDialogVisibility(state, visible) {
      state.settingsDialogVisible = visible
    },

    setToolbarTabs(state, tabs) {
      state.toolbarTabs = tabs
    },

    setActiveTab(state, tab) {
      state.activeTab = tab
    },
  },

  getters: {
    isVirtual(state, getters, rootState) {
      const { isVirtual, visitorCanSwitch } = state.virtual
      const visit_type =
        rootState.auth.user && rootState.auth.user.visit_type
          ? rootState.auth.user.visit_type
          : false
      return isVirtual
        ? visitorCanSwitch
          ? visit_type && visit_type === 'virtual'
          : true
        : false
    },
    langsToSwitch(state) {
      return state.langs.filter(lang => lang.is_active === false)
    },

    rootMenu(state) {
      return state.menu.filter(item => item.parent_id === null)
    },

    showNotifications(state) {
      for (var i = 0; i < state.menu.length; i++) {
        if (
          state.menu[i].module == 'networking' ||
          state.menu[i].module == 'messages'
        )
          return true
      }

      return false
    },

    hasModule: state => moduleName => {
      return state.menu.findIndex(item => item.module === moduleName) !== -1
    },

    roomById: state => roomId => {
      return state.rooms.find(room => room.id === roomId)
    },

    roomId: (state, getters, rootState) => {
      const { roomId } = rootState.route.params
      return roomId || state.rooms[0].id
    },

    room: (state, getters) => {
      const { roomId } = getters
      return _.find(state.rooms, room => room.id == roomId)
    },

    showToolbarTabs: state => {
      return state.toolbarTabs.length > 0
    },

    layout: state => state.layout
  },

  actions: {
    getData({ commit }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        axios
          .get('/common')
          .then(response => {
            const data = response.data
            commit('setData', data)

            commit('showrooms/setShowrooms', data.showrooms, { root: true })
            commit('chat/setRooms', data.chat_rooms, { root: true })
            commit(
              'auth/setTwoFactorAuthenticationEnabled',
              data.two_factor_authentication_enabled,
              { root: true }
            )

            commit('setLoading', false)
            resolve()
          })
          .catch(err => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },
  },
}

export default common
